define('models/country',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                name: '',
                iso_code: '',
                phone_code: 0
            };
        }
    });
});
